import React from 'react';
import Typography from '../../../../shared/components/Typography/Typography';

function PartnerContactsPanel({ contacts, agencies }) {
  const agencyLabel = (contact) => {
    if (contact.agency) return contact.agency.name || contact.agency.socialReason || '-';
    const agency = agencies.find((item) => String(item.id) === String(contact.agencyId));
    return agency?.name || agency?.socialReason || '-';
  };
  return (
    <section className="partner-section" role="tabpanel">
      <div className="partner-section__header"><Typography variant="h6">Contacts de la société</Typography></div>
      {contacts.length === 0 ? <p className="partner-empty">Aucun contact trouvé.</p> : (
        <div className="partner-table-wrap"><table className="partner-table"><thead><tr><th>Nom</th><th>Agence</th><th>Rôle</th><th>Téléphone</th><th>Mobile</th><th>Email</th></tr></thead>
          <tbody>{contacts.map((contact, index) => <tr key={contact.id || contact.email || index}>
            <td>{contact.contactName || [contact.firstName, contact.lastName].filter(Boolean).join(' ') || '-'}</td>
            <td>{agencyLabel(contact)}</td><td>{contact.role || '-'}</td><td>{contact.phone || '-'}</td><td>{contact.mobilePhone || '-'}</td><td>{contact.email || '-'}</td>
          </tr>)}</tbody></table></div>
      )}
    </section>
  );
}

export default PartnerContactsPanel;
